export default __webpack_public_path__ + "static/media/esl.ab978749.png";